import clevertap from "clevertap-web-sdk";
import { useState } from "react";

//scss
import "./style.scss";

//assets
import { SvgNonVeg } from "assets/icons/js/SvgNonVeg";
import { SvgVeg } from "assets/icons/js/SvgVeg";

//components
import ReadMoreWrapper from "components/ReadMoreWrapper";
import { AllMeals } from "../AllMeals";
import ListingTwoColView from "../ListingTwoColView";
import { useTheme } from "components/ListingNew/ListingTheme";

const ListingMeals = ({
	content,
	veg,
	nonVeg,
	menuLink,
	listingList,
	sectionRef,
	color,
	isDiscount,
}: any) => {
	//allAmenities state
	const [openPopup, setOpenPopup] = useState(false);
	const mealCondition =
		listingList?.is_meal_five === 1 && listingList?.meal_chargeable !== "Y";
	const theme = useTheme();
	return (
		<>
			<AllMeals
				open={openPopup}
				setOpen={setOpenPopup}
				listingList={listingList}
			/>

			<div className="row2-container">
				<div className="text__deco" style={{ color: theme?.baseTextColor }}>
					<ReadMoreWrapper>{content}</ReadMoreWrapper>
					{mealCondition && (
						<span className="meal-discount">5% off on pre-booking meals</span>
					)}
				</div>
				<div className="meal-types">
					{veg && (
						<div className="meal-type">
							<SvgVeg />
							<div
								className="text-sm-light"
								style={{ color: theme?.baseTextColor }}
							>
								Veg
							</div>
						</div>
					)}
					{nonVeg && (
						<div className="meal-type">
							<SvgNonVeg />
							<div
								className="text-sm-light"
								style={{ color: theme?.baseTextColor }}
							>
								Non-Veg
							</div>
						</div>
					)}
				</div>
				<span className="btn__container">
					{menuLink && menuLink.length > 1 ? (
						<button
							aria-label="view-all-meals"
							className="listing__button__new"
							style={theme?.borderBtn}
							onClick={() => {
								clevertap.event.push("viewMenu_btn_listing_page", {
									location: window.location.pathname.split("/")[2],
									timestamp: new Date(),
									villaId: listingList?.id,
									villaName: listingList?.file_reference,
									type: "View Menu",
								});
								window.open(menuLink, "_blank");
							}}
						>
							View Menu
						</button>
					) : null}

					{listingList?.meal_charges_ss_share > 0 ? (
						<button
							aria-label="meals-details"
							className="listing__button__new"
							style={theme?.borderBtn}
							onClick={() => {
								clevertap.event.push("viewMealDetails_btn_listing_page", {
									location: window.location.pathname.split("/")[2],
									timestamp: new Date(),
									villaId: listingList?.id,
									villaName: listingList?.file_reference,
									type: "Meal Pricing",
								});
								setOpenPopup(true);
							}}
						>
							Meal Pricing
						</button>
					) : null}
				</span>
			</div>
		</>
	);
};

export default ListingMeals;
